import { SvgVerified } from '@bazaar-marketplace/assets/verified';
import { cn } from '@bazaar-marketplace/utils';
import { NBSP } from '~/constants';

export function VerifiedText(props: {
  text: string;
  svgClassName?: string;
  singleLine?: boolean;
  hideBadge?: boolean;
}) {
  function renderContent() {
    return (
      <>
        <span className={props.singleLine ? 'overflow-hidden text-ellipsis whitespace-nowrap w-full' : ''}>
          {props.text}
          <span className={cn('whitespace-nowrap', props.hideBadge ? 'hidden' : '')}>
            <span aria-hidden>{NBSP}</span>
            <SvgVerified className={cn('size-[14px] inline translate-y-[-2px]', props.svgClassName)} />
          </span>
        </span>
      </>
    );
  }

  if (props.singleLine) {
    return <div className="flex">{renderContent()}</div>;
  }

  return renderContent();
}
